goog.provide('el8.appshared.dialog.editPatient');

goog.require('el8.app.pageLayout');
goog.require('el8.appchart.dialog.deleteChart');
goog.require('el8.appchart.dialog.mergeChart');
goog.require('el8.appchart.permissions');
// Strange circular dep error being reported from this -- commenting out
// goog.require('el8.appchart.refpanel.maint');
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.dialog.inviteToPassport');
goog.require('el8.appshared.dialog.patientFields');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.base');
goog.require('el8.data.employers');
goog.require('el8.data.pharmacies');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.ptdata.model.ptPreferences');
goog.require('el8.service.urls');
goog.require('el8.template.appshared.dialog.editPatient');
goog.require('el8.template.appshared.dialog.patientForm');
goog.require('el8.template.appshared.location');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.base');
goog.require('el8.util.dom');

el8.appshared.dialog.editPatient = (function(){

    // the patient we are editing
    var patient = null;

    // used for the 'Save & Record Payment' button from practice home
    var copayApptId = null;
    // used from practice home to indicate if the patient is missing
    // elgibility info (in which case, we should try to update
    // after this update)
    var doEligibilityCheckOnSave = false;

    // primarily used to communicate out to react when triggers this dialog
    // and want to know when pt has been saved
    var _onSaveCallback = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Edit Patient Details',
        modal: false,
        autoHeight: true,
        position: 'center',
        width: 705,
        contentFn: function() {
            return el8.template.appshared.dialog.editPatient.content({
                physicians: [], // will populate with updatePhysicianOptions
                languages: el8.data.languages.getPrioritizedMaps(),
                phoneTypes: el8.data.phoneTypes,
                races: el8.data.races,
                ethnicities: el8.data.ethnicities,
                sexualOrientations: el8.data.sexualOrientations,
                genderIdentities: el8.data.genderIdentities,
                pharmacies: [],
                kareoIntegrated: el8.data.currPractice.isKareoIntegrated(),
                apptRemindersEnabled: el8Globals.FEATURES.ApptReminders &&
                                      el8.data.practiceSettings.isApptRemindersEnabled(),
                employers: [] // will populate with updateEmployerOptions

            });
        },
        // In read-only mode, the save/discard buttons are disabled and this is the only way to
        // dismiss the dialog
        showXButton: el8Globals.READ_ONLY
    });

    var form = null;
    // bind to pass FormDialog down to url() of mindreader
    var fn = _.bind(el8.appshared.dialog.patientFields.getFields, that);
    form = new el8.uiwidget.Form({
        fields: fn(),
        validationOpts: el8.appshared.dialog.patientFields.patientValidationOpts
    });

    function getForm() {
        return form;
    }


    function _doSave(doPrint, callbackFn) {
        form.disableButton('save')
        if (!form.isValid()) {
          form.enableButton('save')
          return;
        }
        if (!el8.appshared.dialog.patientFields.insuranceFreeTextFieldsValid(form)) {
            el8.uiwidget.alert('The insurance entered is unknown, please select from the dropdown of existing insurances.');
            form.enableButton('save')
            return;
        }
        el8.appservice.notifier.notify('Saving patient info...');

        var postMap = form.getMapped(false, true);
        postMap = el8.appshared.dialog.patientFields.prepareInsuranceDataForPost(postMap, that);
        postMap = el8.appshared.dialog.patientFields.prepareGuarantorDataForPost(postMap, that);

        // this is another strategy to open a printout in a new tab
        // that doesn't require making the request synchronous
        var newTab = null;
        if (doPrint) { newTab = window.open(); }
        $.el8_ajax({
            url: el8.service.urls.get('patientDemographics', [patient.getId()]),
            type: 'POST',
            data: JSON.stringify(postMap),
            success: function(responseObj) {
              try {
                el8.appservice.notifier.notify('Patient info saved.');

                patient.populate(responseObj);
                el8.ptdata.patients.trigger(EVENTS.UPDATED, patient);

                if (el8Globals.APP === 'chart') {
                  el8.ptdata.ptPreferences.populate(responseObj.pt_preferences);

                  if (el8.data.practiceSettings.isHccScoringEnabled()) {
                    el8.ptdata.hccScoreDetails.refresh(el8.appchart.refpanel.demog.triggerRender);
                  } else {
                    el8.appchart.refpanel.demog.triggerRender();
                  }

                  el8.appchart.refpanel.maint.render(true);
                  // for updating PCP rendering in care team members
                  el8.ptdata.ptProviders.load();
                  el8.ptdata.careTeamProviders.load();
                  el8.appchart.providers.main.refreshPatientTeam();
                }


                if (doEligibilityCheckOnSave) {
                  updateMedEligibility(patient);
                }

                that.hide();

                if (doPrint && newTab) {
                  newTab.location.href = el8.service.urls.get('printDemog', [patient.getId()]);
                }
                if (callbackFn) { callbackFn(); }
                if (_onSaveCallback) { _onSaveCallback(patient); }
              } finally {
                // put inside a finally block so the save button doesn't
                // get stuck if we run into an error above
                form.enableButton('save')
              }
            },
            error: function() {
              form.enableButton('save')
            }
        });
    }

    form.addButtonSane('save', 'Save & Close', function() {
        _doSave();
    }, {
      isPrimary: true,
      testId: 'edit-patient-dialog-save-button'
    });
    if (el8Globals.FEATURES.FrontOfficeNewKareo && el8Globals.APP === 'home') {
        form.addButton('save-copay', 'Save & Record Payment', function() {
            var _apptId = copayApptId; // doSave will hide the dialog
            _doSave(false, function() {
                var apptToEdit = el8.practicedata.appts.getById(_apptId);
                el8.apphome.scheduler.dialog.apptDetails.show({
                    appt: apptToEdit,
                    focusField: 'copay'
                });
            });
        });
    }
    form.addButtonSane('print', 'Print & Close', function() {
        _doSave(true);
    }, {
      testId: 'edit-patient-dialog-print-button'
    });
    form.addButtonSane('cancel', 'Discard Changes', function() {
        that.hide();
    }, {
      testId: 'edit-patient-dialog-discard-changes-button'
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(opts) {

        opts = opts || {};

        if (el8Globals.FEATURES.NewDemographics) {
            var onSuccess = null;
            if (opts.onSaveCallback) {
                onSuccess = function onSuccess(rawPatient) {
                    // DemographicsDialog component has a `legasySaveCallback` that will
                    // have already updated the el8 patient model, so we can just grab it
                    // here. We don't need to use `rawPatient` here to update the el8 model.
                    var el8Patient = el8.ptdata.patients.getById(rawPatient.id);
                    opts.onSaveCallback(el8Patient);
                }
            }
            el8React.dispatch.openEditPatientDialog({
                patientId: opts.patientId || el8Globals.PATIENT_ID,
                checkinAppointmentId: opts.copayApptId || null,
                onSuccess: onSuccess
            });
            return;
        }

        super_show.call(that);

        doEligibilityCheckOnSave = false;
        copayApptId = opts.copayApptId || null;
        _onSaveCallback = opts.onSaveCallback ? opts.onSaveCallback : null;

        if (el8Globals.APP === 'home') {
            form.updateButtonCaption('cancel', 'No Changes');
        }

        if (opts.patientId) {
            patient = el8.ptdata.patients.getById(opts.patientId);
            that.setTitle(
                el8.template.appshared.dialog.editPatient.longTitle(patient.asSoyMap())
            );
        } else {
            patient = el8.ptdata.currPatient;
            that.setTitle('Edit Patient Details');
        }

        populateDialog();
        that.adjustPosition();

        // The VIP box gets special handling
        if ((patient.isVip() && !_canRemoveVip()) || (!patient.isVip() && !_canSetVip())) {
            form.getInputField('isVip').prop('disabled', true);
        }
        // Patients who are VIPs can only have their primary provider changed by that provider
        if (patient.isVip() && !_canRemoveVip()) {
            form.getInputField('primaryPhysicianUserId').prop('disabled', true);
        }

        // Might be called from phome on check in where currPatient doesn't exist
        if (el8.ptdata.currPatient) {
            that._guarantor = el8.ptdata.currPatient.getGuarantor();
            el8.appshared.dialog.patientFields.renderGuarantor(that, el8.ptdata.currPatient.getGuarantor());
        }

        // we'll disable the insurance fields if we're one way kareo integrated
        el8.appshared.dialog.patientFields.disableInsuranceFieldsIfOneWayKareoIntegrated(that);
        // reset any insurance error classes from previous openings
        el8.appshared.dialog.patientFields.resetInsuranceFreeTextErrorClasses(that.getForm());

        form.initFocus();
    };

    var super_init = that._init;
    that._init = function() {
        el8.appshared.dialog.patientFields.softLoadPatientFormInfo();
        el8.appshared.dialog.patientFields.addRemoveSettingDependentFields(form);

        super_init.call(that);
        var $content = that.getContentElt();

        el8.appshared.dialog.patientFields.addPharmacyLinkListeners(that); //listeners for .change-pharmacy1 and 2
        el8.appshared.dialog.patientFields.addInsuranceLinkListeners(that);
        el8.appshared.dialog.patientFields.addGuarantorLinkListeners(that);
        el8.appshared.dialog.patientFields.addPatientProviderLinkListeners(that);
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'insurance');
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'race');
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'ethnicity');
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'nok');
        el8.appshared.dialog.patientFields.autoTrimEmailListener(that);
        el8.appshared.dialog.patientFields.populateAndSetReferringProviderState(that);
        el8.appshared.dialog.patientFields.populateAndSetPrimaryCareProviderState(that);
        el8.appshared.dialog.patientFields.addPatientConsentListeners(that);

        if (el8Globals.APP === 'chart') {
            $content.on('click', '.patient-merge-chart',  function(e) {
                el8.appchart.dialog.mergeChart.show();
            });
            $content.on('click', '.patient-delete-chart',  function(e) {
                el8.appchart.dialog.deleteChart.show();
            });
        } else {
            $('.chart-management-section', $content).hide();
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'insurance', false);
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'race', false);
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'ethnicity', false);
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'nok', false);

        copayApptId = null;
        that._primaryInsurance = null;
        that._secondaryInsurance = null;

        that._guarantor = null;
        el8.appshared.dialog.patientFields.renderGuarantor(that);

        $('.elig-section', that.getContentElt()).empty();
        $('.referring-provider-state-section', that.getContentElt()).hide();
    };

    that.getPatient = function() {
        return patient;
    };

    /**
     * When we save an insurance company from the react insurance dialog, we want to
     * populate the insurance company fields with what was created/updated.
     *
     * @param {object} insuranceCompany - the insurance company from redux
     * @param {string} insuranceRank - either primary or secondary
     */
    that.populateInsuranceCompanyFromReact = function(insuranceCompany, insuranceRank) {
        el8.appshared.dialog.patientFields.populateInsuranceCompanyFromReact(that, insuranceCompany, insuranceRank);
    };

    /**
     * When we save an insurance plan from the react insurance dialog, we want to
     * populate the insurance plan fields with what was created/updated.
     *
     * @param {object} insurancePlan - the insurance plan from redux
     * @param {string} insuranceRank - either primary or secondary
     */
    that.populateInsurancePlanFromReact = function(insurancePlan, insuranceRank) {
        el8.appshared.dialog.patientFields.populateInsurancePlanFromReact(that, insurancePlan, insuranceRank);
    };

    /*
     * The parent for all the populate functions below
     */
    function populateDialog() {
        // the list may vary if the current patient has an inactive PCP
        updatePhysicianOptions();

        // the list is practice-dependent.  We only show the list of employers
        // that are associated with the current practice
        el8.appshared.dialog.patientFields.updateEmployerOptions(that, form);
        form.getInputField('employerId').chosen().trigger('chosen:updated');

        // Populate the form with stuff that lives on the patient model
        form.populate(patient.asFormMap(), true); // noTrigger
        populatePatientInsurances();
        // special widget we use here needs to be notified it was changed
        form.getInputField('preferredLanguageId').chosen().trigger('chosen:updated');

        // Populate with data from patient preferences. In the chart, el8.ptdata.ptPreferences
        // will be set, but in other contexts, we need to fetch it
        populatePreferenceFields();

        // populate the pcp fields
        populatePcpFields();
        populateReferringProviderHiddenFields();
        el8.appshared.dialog.patientFields.updateReferringProviderLinks(that);

        // Populate races: trigger update of chosen widget, hide 2nd if needed
        form.getInputField('detailedRace').chosen().trigger('chosen:updated');
        form.getInputField('detailedSecondaryRace').chosen().trigger('chosen:updated');
        // Show or hide select and link
        var secondaryRace = patient.getDetailedSecondaryRace();
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that,
                                                                      'race',
                                                                      secondaryRace ? true : false);

        // Populate ethnicities
        form.getInputField('detailedEthnicity').chosen().trigger('chosen:updated');
        form.getInputField('detailedSecondaryEthnicity').chosen().trigger('chosen:updated');
        var secondaryEth = patient.getDetailedSecondaryEthnicity();
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that,
                                                                      'ethnicity',
                                                                      secondaryEth ? true : false);

        if (patient.getNokFirstName() || patient.getNokLastName() || patient.getNokPhone()) {
            el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'nok', true);
        }

        if (el8.data.currPractice.hasIntegration()) {
            patient.softLoadIntegrations(function(integrations) {
                if (integrations) {
                    var $integrationSection = $('.integrations-section', that.getContentElt());
                    $integrationSection.show();
                    $('#integrations-list', $integrationSection).html(el8.template.appshared.dialog.patientForm.integrations({
                        integrations: integrations
                    }));
                }
            });
        }

        // Show the available apiv2 applications for this practice.
        // We'll merge apps and existing pt consents for display
        el8.data.currPractice.fetchApplications(function(apps) {
            var apps_with_consent = _.filter(apps, function(a) { return a.consent_available && a.is_active; })

            if (!_.isEmpty(apps_with_consent)) {
                el8.appshared.dialog.patientFields.renderConsentLines(that, apps_with_consent);
            }
        });

        // fetch employer data
        patient.loadEmployer(function(employerData) {
            if (employerData.id) {
                form.populate({
                    employerId: employerData.id
                });
            // special widget we use here needs to be notified it was changed
            form.getInputField('employerId').chosen().trigger('chosen:updated');
            }
            // don't need an else case because the dropdown has a default selected option
        });

        patient.loadSmsShortCodeStatus(function (smsShortCodeStatus) {
            var content = el8.template.appshared.dialog.patientForm.smsShortCodeStatus({
                smsShortCodeStatus: smsShortCodeStatus
            });
            $('#sms-shortcode-status-list').html(content);
        });

        if (el8Globals.APP === 'home') {
            checkMedEligibilityStatus();
        }
    }

    function populatePreferenceFields() {
        if (el8Globals.APP === 'chart') {
            form.setVal('apptRemindersOptOut', el8.ptdata.ptPreferences.isApptRemindersOptOut());
            populatePatientPharmacies(el8.ptdata.ptPreferences);

        } else {
            // we don't have a "current patient" context, so we'll need to fetch
            // these preferences async and then populate
            el8.ptdata.ptPreferences.fetchForPatient(patient.getId(), function(ptPreferenceObj) {
                form.setVal('apptRemindersOptOut', ptPreferenceObj.isApptRemindersOptOut());
                populatePatientPharmacies(ptPreferenceObj);
            });
        }
    }

    function populatePatientPharmacies(ptPreferenceObj) {
        var pharmacy1 = el8.data.pharmacies.getByKey(ptPreferenceObj.getPrefPharmacy1Key());
        var pharmacy2 = el8.data.pharmacies.getByKey(ptPreferenceObj.getPrefPharmacy2Key());

        el8.appshared.dialog.patientFields.updatePreferredPharmacy(that, 1, pharmacy1);
        el8.appshared.dialog.patientFields.updatePreferredPharmacy(that, 2, pharmacy2);
    }

    function populatePatientInsurances() {
        // new fields
        if (patient.getPrimaryInsurance().isNonEmpty()) {
            that._primaryInsurance = patient.getPrimaryInsurance();
        } else {
            that._primaryInsurance = null;
        }

        if (patient.getSecondaryInsurance().isNonEmpty()) {
            that._secondaryInsurance = patient.getSecondaryInsurance();
        } else {
            that._secondaryInsurance = null;
        }
        el8.appshared.dialog.patientFields.populateInsuranceFields(that);
    }

    // Render the list of primary physician <option>s
    function updatePhysicianOptions() {
        var physicians = el8.data.practiceUsers.getPhysicianUsers();
        var curProvider = el8.data.practiceUsers.getById(patient.getPrimaryPhysicianUserId());
        if (curProvider && !curProvider.isActive()) {
            // make sure the the current primary physician is in the list, even if they're disabled
            physicians.push({
                id: curProvider.getId(),
                name: curProvider.getFullName(),
                staffId: curProvider.getStaffId()
            });
        }
        /** ARGH, Have to hard-code for DJ/DC **/
        if (el8.data.currPractice.getId() === 73395929092) {
            physicians.reverse();
        }
        form.getInputField('primaryPhysicianUserId').html(
            el8.template.appshared.dialog.patientForm.physicianOptions({
                physicians: physicians
            })
        );
    }

    function populateReferringProviderHiddenFields() {
        form.populate({
            referringProviderModel: patient.getReferringProviderCanonicalId() ? 'CanonicalPhysician' : '',
            referringProviderModelId: patient.getReferringProviderCanonicalId()
        });
    }

    function populatePcpFields() {
        form.populate({
            pcpPhysicianName: patient.getPcpPhysicianName(),
            pcpModel: patient.getPcpCanonicalId() ? 'CanonicalPhysician' : '',
            pcpModelId: patient.getPcpCanonicalId()
        });
    }

    function checkMedEligibilityStatus() {
        $.el8_ajax({
            type: 'GET',
            url: el8.service.urls.get('patientCheckinItems', [patient.getId()]),
            success: function(data) {
                if (!data.eligibility_verified) {
                    doEligibilityCheckOnSave = true;

                    $('.elig-section', that.getContentElt())
                        .html(el8.template.appshared.dialog.editPatient.eligibilityNotice({
                            failureReason: data.eligibility_failure_reason
                        })).show();
                } else {
                    $('.elig-section', that.getContentElt()).empty();
                }
            }
        });
    }

    // Takes a patient param because this may be running
    // after the dialog has hidden and we may want
    // a callback to reference the patient after that
    function updateMedEligibility(_patient) {
        el8.appshared.eligibility.submitRequest(_patient);

        // If we want to open the patientCheckIn dialog
        // after this dialog fails, see below. I think
        // that's likely to be a pain for staff though.
        //
        // el8.appshared.eligibility.submitRequest(_patient, {
        //     failureCb: function() {
        //         el8.apphome.dialog.patientCheckin.showAsNeeded({
        //             patientId: _patient.getId()
        //         });
        //     }
        // });
    }

    // Any admin as well as the primary provider can set a patient to VIP
    // If this logic is changed, also update patients/views.py#_can_set_vip
    function _canSetVip() {
        if (el8.data.currUser.isPracticeAdmin()) {
            return true;
        }

        return _canRemoveVip();
    }

    // Only the primary provider can remove a patient's VIP status
    // If this logic is changed, also update patients/views.py#_can_remove_vip
    function _canRemoveVip() {
        if (el8.data.currUser.isPhysician() && (patient.getPrimaryPhysicianUserId() === el8.data.currUser.getId())) {
            return true;
        }

        return false;
    }

    return that;
})();
